import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/cost_consumers', { params });
  },
  create(data) {
    return axios.post('/v1/cost_consumers', data);
  },
  detail(id) {
    return axios.get(`/v1/cost_consumers/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/cost_consumers/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v1/cost_consumers/${id}`);
  }
};
